const routes = {
  '/': 'Login',
  '/dashboard': 'Dashboard',
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js